import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';
import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

const ThumbnailBottom = ({ text }) => (
  <Box px={4} py={3} display="block" font="h4-regular">
    <Tooltip
      initialPosition={POSITIONS.BOTTOM}
      childrenElement={text}
      hideOnScreenReader
    >
      <Dotdotdot clamp={1}>{text}</Dotdotdot>
    </Tooltip>
  </Box>
);

ThumbnailBottom.propTypes = {
  text: PropTypes.string,
};

export default ThumbnailBottom;
